// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const REVIEW_VERIFIED = "Ov\u011b\u0159en\u00e1 recenze";
export const WIKI_EXP_DRAFT_VERIFIED_BY_PHONE_CALL = "Ov\u011b\u0159eno adminem";
export const WIKI_EXP_GUEST_LABEL = "host";
